<div *ngIf='rounds.length == 0'>
  No rounds yet.
</div>

<div fxLayout='row' class='round-header-title' *ngIf="rounds.length>0" fxHide.lt-md="true">
  <div fxFlex="5">
    #
  </div>
  <div fxFlex='1 1 25%'>
    Course
  </div>
  <div fxFlex>
    Date
  </div>
  <div fxFlex>
    Score
  </div>
  <div fxFlex *ngIf="rounds[0].course_name">
    Adjusted Score
  </div>
  <div fxFlex>
    Rating
  </div>
  <div fxFlex>
    Slope
  </div>
  <div fxFlex>
    Diff
  </div>
  <div fxFlex="75px" *ngIf="rounds[0].course_name" fxLayout="row" fxLayoutAlign="center center">
    Used
  </div>
  <div fxFlex="100px" *ngIf="rounds[0].course_name">
    Exceptional
  </div>
  <div fxFlex="75px" *ngIf="rounds[0].coursename" fxLayout="row" fxLayoutAlign="center center">
    Synched
  </div>
  <div fxFlex="100px" *ngIf="rounds[0].coursename" fxLayout="row" fxLayoutAlign="center center">
  </div>
  <div fxFlex="50px" *ngIf="rounds[0].course_name && isGroupAdmin(rounds[0].group_id)">
  </div>
</div>
<div *ngIf='rounds.length>0 && rounds[0].coursename' fxHide.lt-md="true">
  <div fxLayout='row' *ngFor='let round of rounds;let i=index' class='round-list-item'>
    <div fxFlex="5">
      {{i+1}}
    </div>
    <div fxFlex='1 1 25%'>
      {{round.coursename}}
    </div>
    <div fxFlex>
      {{round.event_date.replace(' ','T') | date:'shortDate'}}
    </div>
    <div fxFlex>
      {{round.total_score}}
    </div>
    <div fxFlex>
      {{round.rating}}
    </div>
    <div fxFlex>
      {{round.slope}}
    </div>
    <div fxFlex>
      {{round.round_hcp}}
    </div>
    <div fxFlex="75px" fxLayout="row" fxLayoutAlign="center center">
      <i class='fa fa-check' *ngIf="+round.usga_round_id>0"></i>
    </div>
    <div fxFlex="100px" fxLayout="row" fxLayoutAlign="center center" *ngIf="!adminView">
      <button mat-icon-button (click)="goToStats(round.group_event_id)" matTooltip="Add/See stats">
        <i class="fa fa-list"></i>
      </button>
      <button mat-icon-button (click)="goToResults(round.group_event_id)" matTooltip="Results">
        <i class="fa fa-trophy"></i>
      </button>
    </div>
    <div fxFlex="100px" fxLayout="row" fxLayoutAlign="center center" *ngIf="adminView">
      <button mat-icon-button (click)="delete(round)" matTooltip="Delete Round" *ngIf="round.group_event_id==0">
        <i *ngIf="!round.deleting" class="fa fa-trash"></i>
        <i *ngIf="round.deleting" class="fa fa-spinner fa-spin"></i>
      </button>
      <button mat-icon-button (click)="deleteBoth(round)" matTooltip="Delete Both Round"
        *ngIf="round.group_event_id!=0">
        <i *ngIf="!round.deleting" style="color:red!important" class="fa fa-trash"></i>
        <i *ngIf="round.deleting" class="fa fa-spinner fa-spin"></i>
      </button>
    </div>
  </div>
</div>

<div *ngIf="rounds.length>0 && rounds[0].course_name" fxHide.lt-md="true">
  <div fxLayout='row' *ngFor='let round of rounds;let i=index' class='round-list-item'
    [ngClass]="{'selected-round': round.used}" (click)="goToResults(round.group_event_id)">
    <div fxFlex="5">
      {{i+1}}
    </div>
    <div fxFlex='1 1 25%'>
      {{round.course_name}}
    </div>
    <div fxFlex>
      {{round.played_at.replace(' ','T') | date:'shortDate'}}
    </div>
    <div fxFlex>
      <span *ngIf="round.total_score">
        {{round.total_score}}
      </span>
      <span *ngIf="!round.total_score">
        n/a
      </span>
    </div>
    <div fxFlex>
      {{round.adjusted_gross_score}}
    </div>
    <div fxFlex>
      {{round.course_rating}}
    </div>
    <div fxFlex>
      {{round.slope_rating}}
    </div>
    <div fxFlex>
      {{round.differential}}
    </div>
    <div fxFlex="75px" fxLayout="row" fxLayoutAlign="center center">
      <i class='fa fa-star' *ngIf="round.used"></i>
    </div>
    <div fxFlex="100px" fxLayout="row" fxLayoutAlign="center center">
      <i class='fa fa-check' *ngIf="round.exceptional"></i>
    </div>
    <div>
      <button mat-icon-button *ngIf="isGroupAdmin(round.group_id)" (click)="modifyScore(round.usga_round_id)"
        matTooltip="Modify">
        <i class="fa fa-pencil"></i>
      </button>
    </div>
  </div>
</div>
<div *ngIf="rounds.length>0" fxHide.gt-sm="true">
  <div fxLayout='column' *ngFor='let round of rounds;let i=index' class='round-list-item' [ngClass]="{'selected-round': round.used}">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" style="height: 40px;">
      <div>
        <span *ngIf="round.event_date">{{round.event_date.replace(' ','T') | date:'shortDate'}}</span>
        <span *ngIf="round.played_at">{{round.played_at.replace(' ','T') | date:'shortDate'}}</span>
      </div>
      <div fxLayout="row">
        <div class="score" [ngClass]="{'score-used': round.used}">
          <div style="padding-top:3px">
            {{round.adjusted_gross_score}}
            {{round.total_score}}
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      {{round.course_name}} 
      {{round.coursename}} 
      <span *ngIf="round.slope">
        {{round.slope}}/{{round.rating}}
      </span>
      <span  *ngIf="round.slope_rating">
          {{round.slope_rating}}/{{round.course_rating}}
      </span>

    </div>
    <div>
        <i>
          Diff:
          {{round.differential}}
          {{round.round_hcp}}
        </i>
        <span *ngIf=round.used>*</span>
      </div>
</div>
</div>